module.exports = __webpack_public_path__ + "img/settings-dark.679267fc.svg";